// extracted by mini-css-extract-plugin
export default {"DayScaleEmptyCell":"DayScaleEmptyCell_DayScaleEmptyCell__Y-yz3"};